import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=e64cff3c&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"
import style0 from "./collapse.vue?vue&type=style&index=0&id=e64cff3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64cff3c",
  null
  
)

export default component.exports